import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Popover } from '@mui/material';
import { Colors, FindLoad, FindSuccessItem, Images, useModal } from 'utils';
import { claimPaymentActions } from 'store';
import { CustomDelByNote, MinLoader } from 'components';
import { remittanceStatusEnums } from '../constants';

const VERIFY_ACTION_TYPE = 'VERIFY_REMITTANCES';
export const ClaimPaymentActions = ({ item, handleAction, afterSuccess }) => {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const openPopper = Boolean(anchorEl);
    const id = openPopper ? 'simple-popover' : undefined;
    const loader = FindLoad(VERIFY_ACTION_TYPE);
    const success = FindSuccessItem(VERIFY_ACTION_TYPE);
    const [selectedId, setSelectedId] = useState(null);
    const { open } = useModal();

    useEffect(() => {
        setSelectedId(null);
    }, []);

    useEffect(() => {
        if (success && anchorEl) {
            setAnchorEl(null);
            setSelectedId(null);
        }
    }, [success]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleVerify = () => {
        setSelectedId(item?.id);
        dispatch(claimPaymentActions.verifyRemittance([item?.id]));
    };

    const handleVoid = () => {
        handleClose();
        open(
            <CustomDelByNote
                info="Void This Payment?"
                text="Voiding this payment will mark it as Void and revert all applied claims to unpaid status. This action cannot be undone."
                handleDel={(closingComment) => {
                    dispatch(claimPaymentActions.voidRemittance(item?.id, { reason: closingComment }));
                }}
                afterSuccess={() => {
                    afterSuccess?.();
                    close();
                }}
                required={false}
                innerText={'Void Payment'}
                inputLabel={'Void Reason (optional)'}
                after
                actionType={'VOID_REMITTANCE'}
            />
        );
    };

    return (
        <div>
            <button className="new-action-btn-box-small" onClick={handleClick}>
                <img src={Images.moreGrayIcon} alt="icon" />
            </button>
            <Popover
                id={id}
                open={openPopper}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            >
                <div className="appt-action-popover">
                    {!item?.verified && (
                        <button onClick={handleVerify}>
                            <div className="flex-align-center" style={{ gap: 8 }}>
                                {loader?.length && selectedId === item?.id ? (
                                    <div style={{ width: 24 }}>
                                        <MinLoader margin={'0'} color={Colors.ThemeBlue} position={'relative'} />
                                    </div>
                                ) : (
                                    <img
                                        src={Images.verified}
                                        alt="icon"
                                        style={{
                                            filter: 'brightness(0) saturate(100%) invert(32%) sepia(5%) saturate(2366%) hue-rotate(177deg) brightness(92%) contrast(88%)',
                                        }}
                                    />
                                )}
                                <p>Verify</p>
                            </div>
                        </button>
                    )}

                    {item?.status !== remittanceStatusEnums.VOID && (
                        <button onClick={handleAction}>
                            <div className="flex-align-center" style={{ gap: 8 }}>
                                <img
                                    src={Images.edit}
                                    alt="icon"
                                    style={{
                                        filter: 'brightness(0) saturate(100%) invert(32%) sepia(5%) saturate(2366%) hue-rotate(177deg) brightness(92%) contrast(88%)',
                                    }}
                                />
                                <p>Edit</p>
                            </div>
                        </button>
                    )}

                    {item?.status !== remittanceStatusEnums.VOID && (
                        <button onClick={handleVoid}>
                            <div className="flex-align-center" style={{ gap: 8 }}>
                                <img src={Images.voidCircle} alt="icon" />
                                <p style={{ color: 'rgb(180, 35, 24)' }}>Void</p>
                            </div>
                        </button>
                    )}
                </div>
            </Popover>
        </div>
    );
};
